import { stringify } from 'query-string';
import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import { TopicFilterNames } from 'components/TopicFilters/shared';
import { EntityTypes, SalesTypes } from 'context/entityContext';
import getCountryIds from 'helpers/getCountryIds';

interface ISourcesBreakdownUrlArgs {
  countryIds?: string[];
  customerFilter?: TopicFilterNames[];
  download?: boolean;
  entityIds: string[];
  entityType: EntityTypes;
  salesType: SalesTypes;
  breakdown?: string;
  region?: string;
  customRegion?: string[] | string;
}

export default function getSourcesBreakdownUrl(
  options: ISourcesBreakdownUrlArgs
): string {
  const {
    countryIds,
    customerFilter,
    download,
    entityIds,
    entityType,
    salesType,
    breakdown = 'all',
    region,
    customRegion,
  } = options;

  const params = stringify({
    countryIds: getCountryIds(countryIds, region, customRegion),
    customerFilter,
    download,
    breakdown,
    regionBreakdown: region && !countryIds && !customRegion ? 'region' : 'none',
  });

  const type = entityTypeToApiType(entityType);

  return `/api/${salesType}/sources/breakdown/${type}/${entityIds}?${params}`;
}
